import React from "react";
import ParticlesBackground from "../components/Effects/ParticlesBackground";
import AuthSidebar from "../components/Auth/AuthSidebar";
import "../styles/pages/Downloads.css";
import { useLanguage } from "../contexts/LanguageContext";

const Download: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="download-page">
      <ParticlesBackground />

      <div className="main-download-container">
        <div className="main-panel">
          <section className="hero-section">
            <h1>{t("downloads", "title")}</h1>

            <div className="download-container">
              <a
                href={`${process.env.PUBLIC_URL}/downloads/AethelburInstaller.exe`}
                className="download-btn"
                download="AethelburInstaller.exe"
              >
                <span>
                  <i className="fas fa-download"></i>{" "}
                  {t("downloads", "windows")}
                </span>
              </a>
            </div>
            <div className="download-container">
              <a
                href={`${process.env.PUBLIC_URL}/downloads/AethelburLauncher.exe`}
                className="download-btn"
                download="AethelburLauncher.exe"
              >
                <span>
                  <i className="fas fa-download"></i> {t("downloads", "mac")}
                </span>
              </a>
            </div>
          </section>
        </div>
        <AuthSidebar />
      </div>
    </div>
  );
};

export default Download;
